'use client';

import {
  LDProvider,
  reactSdkContextFactory,
} from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';

import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';

export const flagsContext = reactSdkContextFactory();

export const LaunchDarklyProvider = (
  props: PropsWithChildren<{ clientId: string | undefined }>
) => {
  const { isDev, isDemo } = useEnvironment();
  const { currentProjectId, user } = useUser();
  if (!currentProjectId) {
    return props.children;
  }

  if (isDemo || isDev) {
    return (
      <flagsContext.Provider
        value={{
          flags: {
            // Amir
            NonCognitoEonAccounts: false,
            SkipOnboarding: false,
            FileExplorerPerSnapshot: false,
            dlsgFrontend: false,
            assistantEnabled: false,
            LlgFrontend: false,
            CostExplorerResourceBreakdown: false,
            CostExplorerGroupByCostType: false,

            // Erez
            enableHourlyBackup: false, // opened only for Fanatics
            AzureSqlVirtualMachineSupport: true,
            ownCustomerOnboardingEnabled: false,
            byovEnabled: true,
            hourlyDlsgPolicyEnabled: false,
            dynamoAdvancedRestoreFlowEnabled: true,
            RdsPitrEnabled: true,
            RestoreVmWithNoNic: true,

            // Moshe
            SapHanaPitrSupport: true,

            // Keren
            RdsRestoreWithoutEncryptionEnabled: false,
            RecordRestoreResultsEnabled: true,
            EC2HighFrequencyBackupEnabled: true,

            // Eldar
            EnableAzureVaultNetworkIsolation: true,

            // Ariel
            AzureSnapshotsDiscoverySupport: true,

            // Ran
            terraformAzureOnboarding: true,
            FSxSupport: true,

            // Tzachi - Consolidate onboarding experience
            consolidateOnboardingExperienceShouldIncludeInteractive: false,

            // Moshe Shelly
            displayJobSteps: false,
            isServiceNowNotificationEnabled: true,

            // Liran - Aurora Global DB
            AuroraGlobalDbDiscoverySupport: false,

            // Eden
            EnableCrossRegionOfflineRestore: true,
          },
          flagKeyMap: {},
          ldClient: undefined,
        }}
      >
        {props.children}
      </flagsContext.Provider>
    );
  }

  if (!props.clientId || !user) {
    return props.children;
  }

  return (
    <LDProvider
      reactOptions={{
        reactContext: flagsContext,
        useCamelCaseFlagKeys: false,
      }}
      clientSideID={props.clientId}
      context={{
        kind: 'multi',
        user: {
          key: currentProjectId, // backward compatibility
          // name: user.givenName,
          // email: user.email,
          // id: user.id,
          name: user.eonAccount.name,
          domain: user.eonAccount.domain,
        },
        organization: {
          key: user.eonAccount.id,
          name: user.eonAccount.name,
          domain: user.eonAccount.domain,
          projectId: currentProjectId,
        },
      }}
      options={
        {
          /* ... */
        }
      }
    >
      {props.children}
    </LDProvider>
  );
};
